import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Banner } from '@wartek-id/banner'

import { useKinerjaHarianTrackEvent } from 'app/KinerjaHarian/hooks/useKinerjaHarianTrackEvent'

interface CardKinerjaHarianPSProps {
  ctaHref?: string
  ctaText?: string
  disabled?: boolean
  isLoading?: boolean
  isActive?: boolean
  isPerencanaanReady?: boolean
  onClick?: () => void | Promise<void>
}

export default function CardKinerjaHarianPS({
  ctaHref,
  ctaText = 'Ke Kinerja Harian',
  disabled = false,
  isLoading = false,
  isActive = false,
  isPerencanaanReady = false,
  onClick,
}: CardKinerjaHarianPSProps) {
  const router = useRouter()
  const { trackEvent } = useKinerjaHarianTrackEvent()

  const handleCta = async () => {
    await onClick?.()

    trackEvent({
      activityType: 'click_kinerja_harian',
      screenName: 'beranda',
    })

    if (ctaHref) {
      router.push(ctaHref)
    }
  }

  React.useEffect(() => {
    if (isActive) {
      trackEvent({
        activityType: 'page_view',
        screenName: 'beranda',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive])

  if (isLoading || !isActive) {
    return null
  }

  return (
    <Card className="p-6 space-y-6">
      <div className="space-y-2">
        <Text variant="heading-sm">Kinerja Harian</Text>
        <Text variant="body" color="subdued">
          Catat kinerja harian agar selaras dan turut mendukung kinerja periodik{' '}
          dan tahunan, sesuai Permen PANRB No. 6 Tahun 2022 dan kebijakan{' '}
          <strong>Pemerintah Daerah</strong>.
        </Text>
      </div>

      {!isPerencanaanReady && (
        <Banner
          type="warning"
          title="Kinerja Harian baru dapat dicatat setelah Perencanaan Kinerja Anda sudah selesai"
          className="!pb-2 !flex-start"
          closable={false}
        />
      )}

      <Button
        color="black"
        disabled={disabled || !isPerencanaanReady}
        isLoading={isLoading}
        onClick={handleCta}
        data-testid="cta-button"
        className="px-8"
        fullWidth
      >
        {ctaText}
      </Button>
    </Card>
  )
}
